<template>
  <div class="row">
    <div class="col-md-8" v-if="loading">
      <h4>loading...</h4>
    </div>
    <div class="col-md-8" v-if="!loading && Object.keys(pagerduty_users).length>0">
        <enhanced-table :datalist="pagerduty_users" />
    </div>
  </div>
</template>
<script>
import LTable from 'src/components/Table.vue'
import axios from "axios";

export default {
  name: 'pager-duty-users',
  components: {
    LTable,
  },
  data () {
    return {
      pagerduty_users: null,
      accessToken: null,
      loading: true,
    }
  },
  async created() {
    try {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData();
    } catch (e) {
      console.error(e)
    }
  },
  methods:{
    loadData() {
      axios
        .get('pagerduty/users?access_token=' + this.accessToken, {})
        .then(response => {
            this.pagerduty_users = response.data;
            this.loading = false;
        });
    },
  },
}

</script>
<style>

</style>
